<template>
  <li :class="['tags-performance-list-item', diffColor]">
    <a
      class="tags-performance-list-item-link"
      :href="item.url"
      target="_blank"
      @click="clickItemHandler(item)"
    >
      <div :class="['tags-performance-list-item-icon', iconClassName]">
        {{ iconText }}
      </div>
      <div class="tags-performance-list-item-content">
        <div class="tags-performance-list-item-information">
          <div class="tags-performance-list-item-name">
            {{ item.name }}
          </div>
          <div class="tags-performance-list-item-diff-percentage">
            近一日股價
            <b class="emphasis-diff-percentage">
              {{ diffPercentage }}
            </b>
          </div>
        </div>
        <div class="tags-performance-list-item-button">
          查看
        </div>
      </div>
    </a>
  </li>
</template>

<script>
export default {
  name: 'TagsPerformanceListItem',
  props: {
    item: {
      type: Object,
      required: true,
      validator(value) {
        return Object.keys(value).includes('name')
          && Object.keys(value).includes('diff_percentage')
          && Object.keys(value).includes('url')
      },
    },
    clickItemHandler: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    diffPercentage() {
      if (this.item.diff_percentage > 0) {
        return `+${this.item.diff_percentage}%`
      }
      if (this.item.diff_percentage < 0) {
        return `${this.item.diff_percentage}%`
      }

      return '+0%'
    },
    iconText() {
      return this.item.diff_percentage === 0 ? '-' : ''
    },
    iconClassName() {
      if (this.item.diff_percentage > 0) {
        return 'icon-font-up'
      }
      if (this.item.diff_percentage < 0) {
        return 'icon-font-down'
      }

      return ''
    },
    diffColor() {
      if (this.item.diff_percentage > 0) {
        return 'color-red'
      }
      if (this.item.diff_percentage < 0) {
        return 'color-green'
      }

      return ''
    },
  },
}
</script>

<style scoped lang="scss">
.color-red {
  .tags-performance-list-item-icon {
    background-color: #ffe9e8;
    color: #ea5e5b;
  }
  .emphasis-diff-percentage {
    color: #ea5e5b;
  }
}
.color-green {
  .tags-performance-list-item-icon {
    background-color: #e3f3e0;
    color: #51A551;
  }
  .emphasis-diff-percentage {
    color: #51A551;
  }
}

.tags-performance-list-item {
  &:last-child > .tags-performance-list-item-link {
    border-bottom: none;
    padding-bottom: 0rem;

    @media (min-width: 768px) {
      padding-bottom: 12px;
    }
  }
}

.tags-performance-list-item-link {
  display: block;
  position: relative;
  margin-top: 1rem;
  padding-bottom: 1rem;
  margin-left: 54px;
  border-bottom: 1px dotted #dfdfdf;
  line-height: normal;
  cursor: pointer;
  text-decoration: none;
  color: #434343;
  @media (min-width: 768px) {
    margin-top: 12px;
    padding-bottom: 12px;
    margin-left: 51px;
  }
}

.tags-performance-list-item-icon {
  position: absolute;
  left: -54px;
  width: 42px;
  height: 42px;
  line-height: 42px;
  font-size: 18px;
  text-align: center;
  background-color: #f1f1f1;
  border-radius: 6px;
  @media (min-width: 768px) {
    left: -51px;
  }

  &::before {
    line-height: 42px;
  }
}
.tags-performance-list-item-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.875rem;
  @media (min-width: 768px) {
    font-size: 13px;
  }
}

.tags-performance-list-item-information {
  width: 75%;
  .tags-performance-list-item-name {
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tags-performance-list-item-diff-percentage {
    margin-top: 3px;
    color: #636363;
  }
}
.tags-performance-list-item-button {
  font-weight: bold;
  padding: 6px 18px;
  background-color: #eaf5fb;
  color: #0386f4;
  border-radius: 15px;
  @media (min-width: 768px) {
    padding: 6px 12px;
  }
}
</style>
